import _ from "lodash";

import { AxiosResponse } from "axios";
import { BaseEntity, IResponseResult } from "@/services/data/base_types";
import base_ds from "@/services/base_datasource_service";
import request from "@/utils/request";
import { EcoObjectType } from "@/services/models-service";
import { numberFormat } from "highcharts";

// Значение, которое по умолчанию выставляется блокам заполнения, если оператор ранее не задавал правил для данной конфигурации
export const DEFAULT_FILL_BLOCK_SHOW_STATE = false;

export class FillBlockShowResponseItem extends BaseEntity {
  id_eco_facility: number | null = null;
  id_cut: string | null = null;
  block: string = "";
  block_group: string = "";
  is_show: boolean = false;
}

// формат получаемых с сервера данных о правилах отображения
export interface FillBlockShowResponse extends BaseEntity {
  facility: EcoObjectType;
  fill_blocks: FillBlockShowResponseItem[];
}

// Набор пар ключ-значение для правил отображения
export interface FillBlocksShowCheckValue {
 [key: string]: boolean;
}

export class FillBlocksShowCheckValues {
  facility: EcoObjectType;
  ok_hn_blocks: FillBlocksShowCheckValue = {};
  purchase_blocks: FillBlocksShowCheckValue = {};
  sale_blocks: FillBlocksShowCheckValue = {};
  transport_costs_blocks: FillBlocksShowCheckValue = {};
  transport_income_blocks: FillBlocksShowCheckValue = {};
}


export const route_ns = `dicts/fill_blocks_show`;

class FillBlocksService {
    public crud = base_ds.getBaseCrud(route_ns);
    public data_source = base_ds.getBaseDataSource(route_ns);

    public async save(data: FillBlockShowResponseItem[], version: number, cut_id: string, id_node: number, year: number, months: number[]): Promise<IResponseResult<FillBlockShowResponse[]>> {
      const allData: any = { data, version, cut_id, id_node, year, months }
      const response: AxiosResponse["data"] = await this.crud.save(allData);
      if (response) {
        return response;
      } else {
        return { data: null };
      }
    }

    // Запрос правил отображения блоков для объектов согласно выбранной срезке и теловому узлу
    public async getWithFilter(id_cut: string, id_node: number): Promise<IResponseResult<FillBlockShowResponse[]>> {
      const route = route_ns +`?filter=[["id_cut","=","${id_cut}"],"and",["id_heat_node","=","${id_node}"]]`;
      const response: AxiosResponse["data"] = await request({
        url: route,
        method: "get",
      });
      if (response) {
        return response;
      } else {
        return { data: null };
      }
    }

    // Запрос правил отображения блоков для объектов согласно выбранной срезке и теловому узлу
    public async getWithECOFilter(version: number, cut_id: string, id_node: number, year: number, months: number[]): Promise<FillBlockShowResponse[]> {
      const route = route_ns + `?filter=[["version","=","${version}"],"and",["cut_id","=","${cut_id}"],"and",["node_id","=","${id_node}"],"and",["year","=","${year}"],"and",["months","in", ${JSON.stringify(months)}]]`;
      const response = await request({
        url: route,
        method: "get",
      });
      let result = [];
      if (response && response.data) {
        result = response.data
      }
      return result;
    }

    // Преобразование загруженных данных об отображаемых блоках в удобный для TableGrid формат
    public transformCheckStatesResponseData(data: FillBlockShowResponse[], baseRow: FillBlocksShowCheckValues): FillBlocksShowCheckValues[] {
      return data.map( (fb): FillBlocksShowCheckValues => {
        let result = _.cloneDeep(baseRow);
        fb.fill_blocks.forEach( fillItem => {
          (result[fillItem.block_group as keyof FillBlocksShowCheckValues] as FillBlocksShowCheckValue)[fillItem.block] = fillItem.is_show;
        });
        return { ...result, facility: fb.facility };
      });
    }
}

  export default new FillBlocksService();
